var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-modal",
    {
      attrs: {
        "modal-class": "sort-update-wrapper vue-need-bootstrap",
        title: "Sorting update",
        "title-class": "h5 font-weight-bold",
        lazy: "",
        centered: "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        size: "md",
      },
      on: {
        close: _setup.onCloseHandler,
        cancel: _setup.onCloseHandler,
        ok: _setup.onConfirmHandler,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ ok, cancel }) {
            return [
              _c(
                "div",
                { staticClass: "d-flex justify-content-center" },
                [
                  _c(_setup.CButton, {
                    attrs: {
                      size: "sm",
                      text: "Cancel",
                      variant: "outline-primary",
                    },
                    on: {
                      click: function ($event) {
                        return cancel()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(_setup.CButton, {
                    staticClass: "ml-1 m-0",
                    attrs: { text: "confirm", size: "sm", variant: "primary" },
                    on: {
                      click: function ($event) {
                        return ok()
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _setup.isVisible,
        callback: function ($$v) {
          _setup.isVisible = $$v
        },
        expression: "isVisible",
      },
    },
    [
      _c("div", { staticClass: "content" }, [
        _c("p", { staticClass: "text-content" }, [
          _vm._v(
            "This sorting update will impact all options linked to this library."
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }